// @owners { team: patients }
import { CommsVerificationInvalidChannel, CommsVerificationStatus } from '@alto/features';
import { useNavigation } from '@alto/navigation';
import React, { useEffect, useRef, useState } from 'react';
import { useVerifyComms } from '~shared/queries/query-keys/verifications';
import { CommsVerificationPageBackground } from './CommsVerificationPageBackground';

export const CommsVerificationStatusContainer = () => {
  const { mutateAsync: verifyComms, isPending: loading } = useVerifyComms();
  const [isVerified, setIsVerified] = useState<boolean | null | undefined>(null);
  const { getParam } = useNavigation<'RouteCommsVerificationStatusAuthed'>();
  const commsChannel = getParam('commsChannel');
  const token = getParam('token');
  // Verify once per channel+token — guard so an effect re-run can't double-submit.
  const firedForRef = useRef<string | null>(null);

  useEffect(() => {
    if (commsChannel !== 'phone' && commsChannel !== 'email') {
      return;
    }
    const key = `${commsChannel}:${token}`;
    if (firedForRef.current === key) {
      return;
    }
    firedForRef.current = key;
    verifyComms({ commsChannel, token })
      .then((verified) => {
        setIsVerified(verified);
        return verified;
      })
      .catch(() => {
        setIsVerified(false);
      });
  }, [commsChannel, token, verifyComms]);

  if (commsChannel !== 'phone' && commsChannel !== 'email') {
    return (
      <CommsVerificationPageBackground>
        <CommsVerificationInvalidChannel authorized />
      </CommsVerificationPageBackground>
    );
  }

  return (
    <CommsVerificationPageBackground>
      <CommsVerificationStatus
        isVerified={isVerified}
        loading={loading}
        commsChannel={commsChannel}
        token={token}
        authorized
      />
    </CommsVerificationPageBackground>
  );
};
